/// <amd-module name="Test/TestSummary/Components/DonutChartLegend" />
import * as React from 'react';
import { css } from "VSSUI/Util";
import { VssComponent, IVssComponentContext, IVssComponentProperties } from "VSS/Platform/Layout";

export interface IDonutChartLegend {
    count: number | string;
    label: string;
    color: string;
    sublabel?: string;
}

export interface IDonutChartLegendProps extends IVssComponentProperties {
    legend: IDonutChartLegend[];
}

export class DonutChartLegendComponent extends VssComponent<IDonutChartLegendProps, {}, IVssComponentContext> {

    public render(): JSX.Element {
        let dataCount: JSX.Element[] = [];
        let dataColor: JSX.Element[] = [];
        let dataLabel: JSX.Element[] = [];

        this.props.legend.forEach((l) => {
            const label: string = l.count.toString() + " " + l.label;
            dataCount.push(<div key={l.label} role="img" aria-label={label} className="legend-cell data-count">{l.count}</div>);
            dataColor.push(<div key={l.label} aria-hidden="true" className="legend-cell data-color" >{this._getLegendCircleElement(l.color)}</div >);
            dataLabel.push(<div key={l.label} aria-hidden="true" className="legend-cell data-value">{l.label}</div>);

            if (!!l.sublabel) {
                const sublabel: string = l.sublabel;
                dataCount.push(<div key={l.sublabel} role="img" aria-label={sublabel} className="legend-sub-cell data-count"></div>);
                dataColor.push(<div key={l.sublabel} aria-hidden="true" className="legend-sub-cell data-color" ></div >);
                dataLabel.push(<div key={l.sublabel} aria-hidden="true" className="legend-sub-cell data-value">{l.sublabel}</div>);
            }
        });
        return (
            <div className={css("donut-legend-container", this.props.cssClass || "")}>
                <div>{dataCount}</div>
                <div>{dataColor}</div>
                <div>{dataLabel}</div>
            </div>
        );
    }

    private _getLegendCircleElement(color: string): JSX.Element {
        const barWidth: string = "14px";
        const barHeight: string = "14px";
        const legendCircle: JSX.Element =
            <span className="legend-circle">
                <svg width={barWidth} height={barHeight}>
                    <circle className="color-circle" cx="7" cy="7" r="7" fill={color} />
                </svg>
            </span>;

        return legendCircle;
    }
}
